/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * The grant's level. Null for a legacy grant that gives neither level: set a level or remove it.
 */
export type VehicleAccessGrantDtoLevel = typeof VehicleAccessGrantDtoLevel[keyof typeof VehicleAccessGrantDtoLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleAccessGrantDtoLevel = {
  ADMIN: 'ADMIN',
  PRIVATE_USE: 'PRIVATE_USE',
} as const;
